const SCHEDULING_QUESTION_PREFIXES: readonly string[] = [
  "__cost_confirmation__",
  "__insufficient_funds__",
];

/** Scheduling approvals never gate Director clarification answers. */
export function isSchedulingQuestionKey(key: string): boolean {
  return SCHEDULING_QUESTION_PREFIXES.some((prefix) => key.startsWith(prefix));
}
